const INDEX_ITEMS = [
  { label: '动作大片', icon: 'ri-sword-line', desc: '肾上腺素飙升' },
  { label: '喜剧电影', icon: 'ri-emotion-laugh-line', desc: '笑到停不下来' },
  { label: '爱情影视', icon: 'ri-heart-line', desc: '甜蜜心动时刻' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', desc: '烧脑推理盛宴' },
  { label: '科幻力作', icon: 'ri-rocket-line', desc: '探索未知世界' },
  { label: '动漫天地', icon: 'ri-ghost-line', desc: '二次元任意门' },
  { label: '纪录片', icon: 'ri-earth-line', desc: '看见真实世界' },
  { label: '恐怖惊悚', icon: 'ri-moon-line', desc: '胆大者的挑战' },
  { label: '综艺娱乐', icon: 'ri-live-line', desc: '轻松解压时光' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            影视索引
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            全类型影视分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按类型快速找到你想看的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {INDEX_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="flex items-center gap-4 p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all cursor-pointer group"
            >
              <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-bold text-foreground-900">{item.label}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}